import './RecordParent.scss';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import { When } from 'react-if';
const delimiter = '.';
export const SonarRecordParent = ({ displayName, onClick, showArrow }) => React.createElement(When, { condition: displayName },
    React.createElement("span", { className: 'record-parent-prefix', onClick: onClick },
        React.createElement(When, { condition: showArrow },
            React.createElement(ArrowLeftOutlined, null)),
        displayName),
    delimiter);
